var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1WaterHeater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 3h-31.5A9.26 9.26 0 0013 12.25v41.5A9.25 9.25 0 0022.24 63H36v3a5.07 5.07 0 001.5 3.5A4.94 4.94 0 0041 71h11a1 1 0 011 1v2h4v-2a5 5 0 00-1.5-3.49A4.94 4.94 0 0052 67H41a1 1 0 01-1-1v-3h13.76A9.25 9.25 0 0063 53.75v-41.5A9.26 9.26 0 0053.75 3zM59 53.75A5.25 5.25 0 0153.75 59h-31.5A5.25 5.25 0 0117 53.75v-41.5A5.25 5.25 0 0122.25 7h31.5A5.25 5.25 0 0159 12.25v41.5zM50 11h5v5h-5v-5zM38 21.5c1.5 6.14 8 11.64 8 17a8 8 0 01-16 0c0-5.36 6.5-10.86 8-17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Water_heater.116cdc51.svg";
export { SvgD1WaterHeater as ReactComponent };